var forEach = require('./forEach');

module.exports = function(args) {
  var count = 0;

  forEach(args, function(key, item) {
    if (typeof item !== 'undefined') {
      count = count + 1;
    }
  });

  return count;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chickencurry/lib/countDefinedItems.js
// module id = 858
// module chunks = 0